// extracted by mini-css-extract-plugin
module.exports = {"bundle-item":"ProductItem_bundle-item__RfVUZ","cus-title":"ProductItem_cus-title__c3uhy"};